import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { S, Field } from '../utils/styles';

export default function Suppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name:'', contact_name:'', phone:'', email:'', address:'', gst_number:'', materials_supplied:'', notes:'' });
  const [saving, setSaving] = useState(false);
  const f = k => v => setForm(p => ({...p, [k]:v}));

  useEffect(() => { load(); }, []);
  const load = () => api.get('/inventory/suppliers').then(r => setSuppliers(r.data));

  const openNew = () => { setEditing(null); setForm({ name:'', contact_name:'', phone:'', email:'', address:'', gst_number:'', materials_supplied:'', notes:'' }); setShowForm(true); };
  const openEdit = s => { setEditing(s); setForm({ name:s.name, contact_name:s.contact_name||'', phone:s.phone||'', email:s.email||'', address:s.address||'', gst_number:s.gst_number||'', materials_supplied:s.materials_supplied||'', notes:s.notes||'' }); setShowForm(true); };

  const save = async () => {
    if (!form.name) return;
    setSaving(true);
    try {
      if (editing) await api.put(`/inventory/suppliers/${editing.id}`, form);
      else await api.post('/inventory/suppliers', form);
      load(); setShowForm(false); setEditing(null);
    } catch(e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h1 style={{ fontSize:22, fontWeight:600, margin:0 }}>Suppliers</h1>
          <div style={{ fontSize:13, color:'#6b7280', marginTop:3 }}>Raw material suppliers — coil, rubber, nuts, boxes etc.</div>
        </div>
        <button onClick={openNew} style={S.btnPrimary}>+ Add supplier</button>
      </div>

      <div style={{ background:'#fff', borderRadius:10, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead><tr>{['Supplier name','Contact','Phone','GST Number','Address','Materials supplied',''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {suppliers.map(s => (
              <tr key={s.id} style={{ borderBottom:'1px solid #f3f4f6' }}>
                <td style={{ ...S.td, fontWeight:500 }}>{s.name}</td>
                <td style={{ ...S.td, color:'#6b7280' }}>{s.contact_name||'—'}</td>
                <td style={{ ...S.td, color:'#6b7280' }}>{s.phone||'—'}</td>
                <td style={{ ...S.td, color:'#6b7280', fontSize:12 }}>{s.gst_number||'—'}</td>
                <td style={{ ...S.td, fontSize:12, color:'#6b7280', maxWidth:200 }}>{s.address||'—'}</td>
                <td style={{ ...S.td, fontSize:12, color:'#374151' }}>{s.materials_supplied||'—'}</td>
                <td style={S.td}><button onClick={() => openEdit(s)} style={{ ...S.btnSm, background:'#f3f4f6', color:'#374151' }}>Edit</button></td>
              </tr>
            ))}
            {suppliers.length === 0 && <tr><td colSpan={7} style={{ textAlign:'center', padding:32, color:'#9ca3af' }}>No suppliers yet</td></tr>}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div style={S.overlay}>
          <div style={{ ...S.modal, width:560 }}>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:16 }}>{editing ? 'Edit supplier' : 'Add supplier'}</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
              <Field label="Supplier name *" value={form.name} onChange={f('name')} />
              <Field label="Contact name" value={form.contact_name} onChange={f('contact_name')} />
              <Field label="Phone" value={form.phone} onChange={f('phone')} placeholder="+91 ..." />
              <Field label="Email" value={form.email} onChange={f('email')} />
              <Field label="GST Number" value={form.gst_number} onChange={f('gst_number')} placeholder="e.g. 27AAAFG1388D1ZN" />
              <Field label="Materials supplied" value={form.materials_supplied} onChange={f('materials_supplied')} placeholder="e.g. MS coils, nuts" />
              <div style={{ gridColumn:'span 2' }}>
                <label style={S.label}>Full address</label>
                <textarea value={form.address} onChange={e => f('address')(e.target.value)} style={{ ...S.input, height:72, resize:'vertical', fontSize:12 }} placeholder="Complete delivery address" />
              </div>
              <div style={{ gridColumn:'span 2' }}>
                <label style={S.label}>Notes</label>
                <textarea value={form.notes} onChange={e => f('notes')(e.target.value)} style={{ ...S.input, height:48, resize:'vertical' }} />
              </div>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={save} disabled={saving||!form.name} style={S.btnPrimary}>{saving?'Saving...':'Save supplier'}</button>
              <button onClick={() => setShowForm(false)} style={S.btnSecondary}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
